import React, { useRef } from "react";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import PaymentInvoice from "./PaymentInvoice";
import { LoanRepayment } from "../../types/loanRepayment";
import { SupplierPayment } from "../../types/supplierPayment";

interface PaymentInvoiceHandlerProps {
    type: "loan" | "supplier";
    invoice: LoanRepayment | SupplierPayment;
    getPartyName: () => string;
    getPaymentMethodLabel: (code?: string) => string;
    buttonText?: string;
}

const PaymentInvoiceHandler: React.FC<PaymentInvoiceHandlerProps> = ({
    type,
    invoice,
    getPartyName,
    getPaymentMethodLabel,
    buttonText = "Print Invoice",
}) => {
    const printRef = useRef<HTMLDivElement>(null);

    const handlePrint = useReactToPrint({
        contentRef: printRef,  
        documentTitle:
            type === "loan" ? "Loan Repayment Invoice" : "Supplier Payment Invoice",
    });

    return (
        <>
            <Button
                icon={<PrinterOutlined />}
                onClick={handlePrint}
                type="primary"
                disabled={!invoice}
            >
                {buttonText}
            </Button>
            <div style={{ display: "none" }}>
                {invoice && (
                    <PaymentInvoice
                        ref={printRef}
                        type={type}
                        invoice={invoice}
                        getPartyName={getPartyName}
                        getPaymentMethodLabel={getPaymentMethodLabel}
                    />
                )}
            </div>
        </>
    );
};

export default PaymentInvoiceHandler;
